import {effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import RackMacro from "effects/RackMacro.js";
import ParameterContext from 'effects/ParameterContext.js';
import {setPadEffects} from 'actions/index.js';

export default superclass => class extends superclass {
    createEffectRack() {
        this.send = this.sequencerEngine.sends.createNewSend(this);
        let fx = initializeEffect("Effect Rack", this.sequencerEngine);
        fx.pad = this;
        fx.context = new ParameterContext().forSubSequence(this.subSequence);
        this.effectRack = fx;
        this.send.addEffect(fx);
        this.fxMacro = new RackMacro(
            "Pad Send",
            this.sequencerEngine,
            new ParameterContext().forSubSequence(
                this.subSequence));
        this.fxMacro.macroParameter.isAlwaysLocked = true;
    }

    linkEffectRackContext() {
        if (this.effectRack) {
            this.effectRack.pad = this;
            this.effectRack.registerContext(
                new ParameterContext().forSubSequence(this.subSequence)
            );
        }
    }

    get effects() {
        return this.effectRack ? this.effectRack.effects : [];
    }

    get effectsChain() {
        return this.effectRack;
    }

    get sendNumber() {
        return this.sequencerEngine.sends.sends.indexOf(this.send);
    }

    addRackEffect(... args) {
        super.addRackEffect(...args);
        this.updateEffectRedux();
    }

    updateEffectRedux(effects=[...this.effectRack.effects]) {
        this.dispatch(
            setPadEffects(this.id, effects));
    }

    onTrackAdded(track) {
        if (this.fxMacro) {
            this.fxMacro.addParameter(
                track.sendNodeVolumeParameters[this.sendNumber], 0, 1);
        }
    }

    syncTracksToEffects() {
        this.fxMacro = new RackMacro(
            "Pad Send",
            this.sequencerEngine,
            new ParameterContext().forSubSequence(
                this.subSequence));
        this.fxMacro.macroParameter.isAlwaysLocked = true;
        if (this.fxMacroValue !== undefined) {
            this.fxMacro.macroParameter.set(this.fxMacroValue);
        }
        if (this.fxMacroJson) {
            this.fxMacro.macroParameter.fromJson(this.fxMacroJson, this.sequencerEngine);
        }
        this.tracks.filter(x => x).forEach(
            x => this.onTrackAdded(x));
        this.linkEffectRackContext();

    }

    onTrackRemoved(track) {
        if (this.fxMacro) {
            this.fxMacro.unmapParameter(
                track.sendNodeVolumeParameters[this.sendNumber], false);
            track.sendNodeVolumeParameters[this.sendNumber].set(0);
        }
    }
}
